import { useAppDispatch, useAppSelector } from './redux';
import {
  getIsUserPrivateDoctor,
  getUserRole,
} from 'applicaiton/sessionStorage/auth';
import { UserRoles } from 'applicaiton/constants/userRoles';
import { useState } from 'react';
import { getCustomerBillingLink } from 'applicaiton/store/reducers/ClinicOwner/ActionCreators';

/**
 * Custom hook for Clinic Owner related data
 */
export const useClinicOwner = () => {
  const dispatch = useAppDispatch();
  const { currentClinicOwner, isLoading } = useAppSelector(
    (state) => state.clinicOwnerSlice,
  );
  const userRole = getUserRole();
  const isUserRoleClinicOwner = userRole?.includes(UserRoles.clinicOwner);
  const [isPaymentAccountActive, setIsPaymentAccountActive] = useState(false);

  /**
   * Function to update the payment account status by fetching the billing link and updating the state accordingly
   */
  const updatePaymentAccountStatus = async () => {
    if (currentClinicOwner?.id) {
      await dispatch(getCustomerBillingLink(currentClinicOwner.id!)).then(
        (data) => {
          if (data.meta.requestStatus === 'fulfilled') {
            setIsPaymentAccountActive(data.payload);
          }
        },
      );
    }
  };

  /**
   * Boolean value to check if the user is a private doctor
   */
  const isPrivateDoctor = getIsUserPrivateDoctor();
  return {
    isLoading,
    isUserRoleClinicOwner,
    isPrivateDoctor,
    isPaymentAccountActive,
    updatePaymentAccountStatus,
  };
};
